import { ReactNode } from 'react';
import { TransactionDataType } from './printInfoModal';

interface HeaderPrintableContentType {
  children?: ReactNode;
  title?: string;
  transaction?: TransactionDataType[];
}

export const PaymentsPrintableContent = (props: HeaderPrintableContentType) => {
  return (
    <>
      <div className='requisites-title'>{props.title}</div>
      <div className='requisites-table'>
        {props.transaction?.map((item, index) => (
          <div key={index} className='requisites-row'>
            <div className='requisites-cell header'>{item.label}</div>
            <div className='requisites-cell'>{item.value}</div>
          </div>
        ))}
      </div>
    </>
  );
};
